module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAArBAMAAABVxc9ZAAAAKlBMVEVHcEzPr2/IqGvJp2zIp2zIp2vJqmrJp2zIqGzIqGvJqGzHp2vJqGvJqGw1oUdbAAAADXRSTlMAEJ9gz+8wj1Bwv0Dfe2g6ZwAAAEdJREFUGFdj4GAAAQ4BhloFEMNWgUHkEpBmvmrAwOgLFLI9BuQxXWbgviIAktc1SHUE62C66QoWYGBYGwahGcShAsMcUDvEAKLNEzWrl+17AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 0